const setSpecialties = (state, specialties) => {
  Object.assign(state, { specialties })
}

const setSubspecialties = (state, { specialtyId, subSpecialties }) => {
  Object.assign(state, {
    subSpecialties: {
      ...state.subSpecialties,
      [specialtyId]: subSpecialties
    }
  })
}

const setSpecialistData = (state, data) => {
  Object.assign(state, data)
}

export default {
  setSpecialties,
  setSubspecialties,
  setSpecialistData
}
